import { useEffect, useRef } from 'react';

import NewKioskModal from './lib/New/NewKioskModal';
import EditKioskModal from './lib/Edit/EditKioskModal';

const KioskModal = ({ isOpen, handleClose, item, tableData }) => {
  // Both modals stay mounted so their exit animation can play; retain the last
  // item so the edit modal keeps its content while it animates closed.
  const lastItemRef = useRef(null);

  useEffect(() => {
    if (item) lastItemRef.current = item;
  }, [item]);

  return (
    <>
      <NewKioskModal
        isOpen={isOpen && !item}
        handleClose={handleClose}
        kioskNr={(tableData?.length || 0) + 1}
        kiosks={tableData}
      />
      <EditKioskModal
        isOpen={isOpen && !!item}
        kiosk={item || lastItemRef.current}
        setKiosk={handleClose}
      />
    </>
  );
};

export default KioskModal;
